import { useEffect } from 'react';

export const NEXT_KEY = 'ArrowRight';
export const PREV_KEY = 'ArrowLeft';
export type ArrowKey = typeof NEXT_KEY | typeof PREV_KEY;

type ArrowKeysPayload = {
    shouldHandle?: boolean;
    onLeftPress: () => void;
    onRightPress: () => void;
};

export function useHandleArrowKeyPress({
    shouldHandle = true,
    onLeftPress,
    onRightPress,
}: ArrowKeysPayload): void {
    useEffect(() => {
        function handleKeyPress(event: KeyboardEvent): void {
            switch (event.key) {
                case PREV_KEY:
                    onLeftPress();
                    break;
                case NEXT_KEY:
                    onRightPress();
                    break;
            }
        }
        if (shouldHandle) {
            window.document.addEventListener('keydown', handleKeyPress, false);
        }

        return () => {
            window.document.removeEventListener('keydown', handleKeyPress);
        };
    }, [shouldHandle, onLeftPress, onRightPress]);
}
